// TODO: make menu items and urls dynamic/fetch from backend

export const NAV_SUB_MENU_UPPER = [
  { label: "Nachrichten", href: "/m-nachrichten.html" },
  { label: "Anzeigen", href: "/m-meine-anzeigen.html" },
  { label: "Einstellungen", href: "/m-einstellungen.html" },
];

export const NAV_SUB_MENU_LOWER = [
  { label: "Merkliste", href: "/m-merkliste.html" },
  { label: "Nutzer", href: "/m-meine-nutzer.html" },
  { label: "Suchaufträge", href: "/m-meine-suchen.html" },
];

export const COOKIE_LOGIN_OVERLAY = "overlayV21";
export const COOKIE_LOGIN_OVERLAY_MAX_AGE = 31536365; // 365 days in seconds
